import { useRef } from 'react';
import isEqual from 'react-fast-compare';
export var MouseButton;
(function (MouseButton) {
    MouseButton[MouseButton["Other"] = -1] = "Other";
    MouseButton[MouseButton["Main"] = 0] = "Main";
    MouseButton[MouseButton["Auxiliary"] = 1] = "Auxiliary";
    MouseButton[MouseButton["Secondary"] = 2] = "Secondary";
})(MouseButton || (MouseButton = {}));
export function getClickType(event) {
    var buttonClicked = event.which - 1 || event.button;
    if (buttonClicked < 0 || buttonClicked > 2) {
        return MouseButton.Other;
    }
    return buttonClicked;
}
// TODO move to shared
// This hook memoizes a value passed based on deep equality.
// Note that it doesn't save you on calculation time like useMemo,
// and it can get slow on huge objects. However it can help you avoid
// re-renders by keeping the value reference identical.
export function useDeepEqualMemo(value) {
    var memoizedValue = useRef(value);
    // only update the value if it's not deep equal
    if (!isEqual(value, memoizedValue.current)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
//# sourceMappingURL=helpers.js.map